export default __webpack_public_path__ + "static/media/logo.4b70cb17.svg";